import styled from '@emotion/styled';

import Box from '../../components/Box';

// Local Variables
const asideMinWidth = 350;
const containerMaxWidth = 752;

export const showPageContainerClassName = 'show-page-container';
export const showPageAsideClassName = 'show-page-aside';

export const ShowPageContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing * 4,
  width: '100%',

  [theme.components.mediaQueries.lg.min]: {
    flexWrap: 'nowrap',

    [`& .${showPageContainerClassName}`]: {
      maxWidth: containerMaxWidth,
    },

    [`& .${showPageAsideClassName}`]: {
      maxWidth: asideMinWidth + 100,
      minWidth: asideMinWidth,
    },
  },
}));
